import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dv7rbrma47: FaireBrandEntity = {
  token: "b_dv7rbrma47",
  type: "brand",
  name: "Maxi Health",
  avatarUrl:
    "https://cdn.faire.com/fastly/32b141c325698f44d0cdff9b6bd31380c0368317917c083c99f7197702a25b98.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9dcfff1dec1f82548089775508d3d3144f82b108a027b4d5e9a8a2c54e011ff9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/32b141c325698f44d0cdff9b6bd31380c0368317917c083c99f7197702a25b98.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9dcfff1dec1f82548089775508d3d3144f82b108a027b4d5e9a8a2c54e011ff9.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "In 1974 Doctor Jack Friedman P.H.D. and his brother Edward had a vision. That vision was to provide state-of-the-art  dietary supplements that are kosher certified. We achieved that with 362 products (most available in choice of sizes)",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:31.788Z",
    importedBy: "entity-db-cli",
  },
};
